import Flight from './Flight';
import Transfer from './Transfer';
import Hotel from './Hotel';
import Excursion from './Excursion';
import Visa from './Visa';
import Insurance from './Insurance';
import Ship from './Ship';
import HotelAdditional from './HotelAdditional';
import ShipAdditional from './ShipAdditional';
import Other from './Other';

export default function (service) {
  switch (service.value) {
    case 1:
      return new Flight({ service });
    case 2:
      return new Transfer({ service });
    case 3:
      return new Hotel({ service });
    case 4:
      return new Excursion({ service });
    case 5:
      return new Visa({ service });
    case 6:
      return new Insurance({ service });
    case 7:
      return new Ship({ service });
    case 8:
      return new HotelAdditional({ service });
    case 9:
      return new ShipAdditional({ service });
    case 10:
      return new Flight({ service });
    default:
      return new Other({ service });
  }
}
